import {_} from 'lodash';
import {IDropdownButton} from "../";
import {ITranslationParams} from "../../../index";
import dropdown_buttonHtml from './dropdown-button.html?raw';

export const template = dropdown_buttonHtml;

export class viewModel {
    constructor(private button: IDropdownButton) {
    }

    private getLabel(): string | ITranslationParams {
        const lab = this.button.label
        if (lab == null) {
            return ''
        }
        if (_.isFunction(lab)) {
            const resolved = (lab as () => string | ITranslationParams | null)()
            return (resolved ?? '') as string | ITranslationParams
        }
        return lab as string | ITranslationParams
    }

    private getButtonAttributes(): Record<string, string | number | null | undefined> {
        return {
            ...this.button.attributes,
            title: this.button.description?.(),
        }
    }

    private getLinkAttributes(): Record<string, string | number | null | undefined> {
        return {
            ...this.getButtonAttributes(),
            href: this.button.href?.(),
            target: this.button.target ?? null,
        }
    }
}

